/**
 * Application-wide constants and configuration
 */

export const APP_NAME = 'headhunter.tn'

export const APP_CONFIG = {
  name: APP_NAME,
  // Add other app-wide constants here as needed
}
